import { render } from "./Desktop.vue?vue&type=template&id=19c6e89e&scoped=true"
import script from "./Desktop.vue?vue&type=script&lang=js"
export * from "./Desktop.vue?vue&type=script&lang=js"

import "./Desktop.vue?vue&type=style&index=0&id=19c6e89e&scoped=true&lang=css"
import "./Desktop.vue?vue&type=style&index=1&id=19c6e89e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c6e89e"]])

export default __exports__